export default __webpack_public_path__ + "static/media/business.821b3e21.jpg";